module.exports = __webpack_public_path__ + "static/media/icon_127.b1d5da88.svg";